import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SicherheitPage from "../pages/article/sicherheit/page";
import VergleichPage from "../pages/article/vergleich/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/artikel/oopbuy-sicherheit",
    element: <SicherheitPage />,
  },
  {
    path: "/artikel/oopbuy-vergleich",
    element: <VergleichPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;